module.exports = __webpack_public_path__ + "img/چرمی-جیب-دار.0babc227.png";